import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcRestService} from 'exc-rest';
import {DefaultSettingsService} from '../default-settings-service.service';
import {ActivatedRoute} from '@angular/router';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcListConfig} from 'exc-controls';
import {ExcTab} from 'exc-tab';
import {AuditDetailsComponent} from '../audit-details/audit-details.component';
import {ModalAssignReviewsComponent} from '../modals/modal-assign-reviews/modal-assign-reviews.component';
import {ExcFilter, ExcFilterCondition, ExcSort, FilterSortService} from '../filter-sort-service.service';
import {AuditReviewComponent} from '../audit-review/audit-review.component';
import {ExcSigninService} from 'exc-signin';
import {ReviewActionService} from '../review-action-service';

@Component({
  selector: 'app-review-inbox',
  templateUrl: './review-inbox.component.html',
  styles: []
})
export class ReviewInboxComponent extends ExcTranslation implements OnInit {
  @ViewChild('filterMenu') filterMenu;
  listconfig: ExcListConfig = new ExcListConfig();
  searchValue: string = null;
  data: any[] = [];
  selectedItems = [];
  reviewEditors = [];
  lstFilters: ExcFilter[] = [];
  lstSort: ExcSort[] = [];
  constructor(private excRest: ExcRestService, private excDss: DefaultSettingsService,
              private excFss: FilterSortService, private excSec: ExcSigninService, private excRas: ReviewActionService) {
    super();
    const _self = this;
    _self.listconfig.selectionMode = _self.excSec.isFeatured('CLI_REVDSP_CU') ? 'multi' : 'none';
    _self.listconfig.paging = {pagingTotalRows: 0, pagingTotalPages: 0, pagingPage: 0, pagingPageSize: 10};
    _self.listconfig.OnSearch = function (searchValue) {
      _self.searchValue = searchValue || '';
      _self.initialLoad();
    };
    _self.listconfig.OnPageChanged = (pageNo) => {
      _self.listconfig.paging.pagingPage = pageNo;
      _self.initialLoad();
    };
    _self.listconfig.OnRefresh = () => {
      _self.initialLoad();
    };
    _self.listconfig.OnFilterClick = (event) => {
      _self.filterMenu.show(event);
    };
    _self.listconfig.OnFilter = () => { };
    // _self.listconfig.OnDetailLink = (item) => {
    //   new ExcTab(item.DealerName, AuditDetailsComponent, item, item.DealerID, {
    //     Unique: true, ReloadParent: function () {
    //     }
    //   }, true).Open();
    // };
    _self.listconfig.OnSelectionChanged = (selectedItems) => {
      _self.selectedItems = selectedItems;
    };
  }
  openAudit(item) {
    new ExcTab(item.DealerName + ' - ' + item.AuditID, AuditDetailsComponent, item, item.AuditID, {
      Unique: true, ReloadParent: function () {
      }
    }, true).Open();
  }
  openReview(item) {
    new ExcTab(item.DealerName + ' - ' + item.AuditID, AuditReviewComponent, item, item.DealerID, {
      Unique: true, ReloadParent: function () {
      }
    }, true).Open();
  }
  applyFilter() {
    this.filterMenu.hide();
    this.initialLoad();
  }
  resetFilter() {
    this.excFss.ResetFilter(this.lstFilters, this.lstSort);
    this.filterMenu.hide();
    this.initialLoad();
  }
  ngOnInit() {
    const _self = this;
    _self.lstFilters =  [
        new ExcFilter(1, 'Audit', 'AuditIsGroup', new ExcFilterCondition('=', 1), 'fltPicked', 'Globals.GroupAudit', false)
      , new ExcFilter(1, 'Audit', 'Auftr_IsPicked', new ExcFilterCondition('=', true), 'fltGroup', 'Globals.PickedCheck', false)
      , new ExcFilter(1, 'Audit', 'AuditLevel', new ExcFilterCondition('=', 2), 'fltLevel2', _self.getGlobal('AuditOnLevel', {lvl: (_self.excDss.MandantSettings['Labels']['DealerLevel2'] || _self.getGlobal('DealerLevel2'))}), false)
      , new ExcFilter(1, 'Audit', 'AuditLevel', new ExcFilterCondition('=', 3), 'fltLevel3', _self.getGlobal('AuditOnLevel', {lvl: (_self.excDss.MandantSettings['Labels']['DealerLevel3'] || _self.getGlobal('DealerLevel3'))}), false)
      , new ExcFilter(2, '', 'DealerName', new ExcFilterCondition('like', ''), 'fltSearchDealerName', 'Globals.DealerName', false)
      , new ExcFilter(2, '', 'DealerLevel1', new ExcFilterCondition('like', ''), 'fltSearchDealerLevel1', (this.excDss.MandantSettings['Labels']['DealerLevel1'] || 'Globals.DealerLevel1'), false)
      , new ExcFilter(2, '', 'DealerLevel2', new ExcFilterCondition('like', ''), 'fltSearchDealerLevel2', (this.excDss.MandantSettings['Labels']['DealerLevel2'] || 'Globals.DealerLevel2'), false)
    ];
    _self.lstSort = [
      new ExcSort('AuditEnd', 0, 'Globals.InboxDate', 2)
      , new ExcSort('AuditTotalStock', 0, 'Globals.AmountTotalStock', 0)
      , new ExcSort('AuditFindings', 0, 'Globals.AmountFindings', 0)
      , new ExcSort('AuditFindingsCrit', 0, 'Globals.AmountFindingsCrit', 0)
    ];
    for (const x of _self.lstFilters) {
      x.Container = _self.lstFilters;
    }
    for (const x of _self.lstSort) {
      x.Container = _self.lstSort;
    }
    this.initialLoad();
  }
  loadEditors() {
    const editorsUrl = this.excRest.computeUrl('ReviewEditorR_List', {});
    this.excRest.get(editorsUrl, {}).subscribe(ret => {
      this.reviewEditors = ret.ReviewEditors || [];
    });
  }
  createReviewGroupWizard(data) {
    this.excRas.CreateGroupWizard(data).subscribe(ret => {
      if (ret === true) {
        this.initialLoad();
      }
    });
  }
  createReviewGroupManual() {
    this.excRas.CreateGroupManual([], this.selectedItems).subscribe(r => {
      this.initialLoad();
    });
  }
  initialLoad () {
    const _self = this;
    const url = _self.excRest.computeUrl('ReviewR_ListOpen', {fts: this.searchValue == null ? '' : this.searchValue});
    let mi = this.listconfig.GetMetaInfo();
    mi =  this.excFss.ApplyFilter(mi, this.lstFilters, this.lstSort);
    _self.listconfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret !== null) {
        _self.data = ret.data;
        _self.listconfig.paging = ret.paging;
        if (this.reviewEditors === null || this.reviewEditors.length === 0) {
          _self.loadEditors();
        }
      } else {
        _self.data = [];
      }
      _self.listconfig.isLoading = false;
    });
  }
  openAssignmentModal() {
    const _self = this;
    if (this.selectedItems.length > 0) {
      const audits = this.selectedItems.reduce((currentString, currentItem, index) =>
          `${currentString}${currentItem.AuditID}${index < this.selectedItems.length - 1 ? '|' : ''}`
        , '');
      ExcCoreModule.showModal(ModalAssignReviewsComponent, null, 'm', {reviewEditors: this.reviewEditors}, false).subscribe(r => {
        r && r.proceed && _self.excRest.post(_self.excRest.computeUrl('ReviewU_Assign', {EditorID: r.selectedEditor}), {Audits: audits, Comment: r.remarks}, {}).subscribe(ret => {
         if (ret && ret.success === true) {
           _self.initialLoad();
           _self.selectedItems = [];
         }
        });
      });
    }
  }
    getAvatarClass(data) {
      return data.AuditType === 16
        ? data.AuditIsPicked ? 'fa-mobile th-warning' : 'fa-mobile th-secondary'
        : data.AuditIsPicked ? 'fa-user-secret th-warning' : 'fa-user-secret th-secondary';
    }
}
